import { useCompoundBody } from "@react-three/cannon"
import { useGLTF } from "@react-three/drei"
import { useRef } from "react"
import { Group, Material, Mesh } from "three"
import { ObjectProps, useDragConstraint } from "../utils"
import { asset } from "../../consts"
import type { GLTF } from "three-stdlib/loaders/GLTFLoader";

interface ComputerMouseGLTF extends GLTF {
  materials: {
    default: Material
    Liquid: Material
  }
  nodes: {
    'ComputerMouse_mesh': Mesh
  }
}
export default ({position, rotation}: ObjectProps) => {
  const { nodes, materials } = useGLTF(asset('/models/ComputerMouse.glb')) as any as ComputerMouseGLTF
  const [ref] = useCompoundBody(() => ({
    mass: 1,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { args: [0.5, 0.3, 1], mass: 1, position: [0, 0.2, 0], type: 'Box', rotation: [0, Math.PI, 0] },
    ], 
    material: {
      friction: 0.8,
      restitution: 0.3,
    },
    type: 'Dynamic',
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind} dispose={null}>
      <group scale={[0.25, 0.25, 0.25]}>
        <mesh
          receiveShadow
          castShadow
          material={materials.default}
          geometry={nodes['ComputerMouse_mesh'].geometry}
        />
      </group>
    </group>
  );
};
